import type { AgencyName } from '@/types'

export const AgencyNames: Record<AgencyName, AgencyName> = {
  CAPES: 'CAPES',
  CNPQ: 'CNPQ',
  FAPESB: 'FAPESB',
  OUTRAS: 'OUTRAS',
}
